import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { ApplicationConfig } from '../../config/config';
import { UrlUtil } from '../../config/urlutil';
import { PERequest } from '../../model/userdata-model';

@Injectable({
  providedIn: 'root'
})
/**
 * This is the service class that connects to the HTML fragment from AEM Content for Homepage
 */
export class ContentBodyService implements OnInit {
  private data: Observable<any>;
  private htmlFragment = '';

  constructor(
    private _http: HttpClient,
    private config: ApplicationConfig,
    private urlUtil: UrlUtil,
    private cookieHelper: CookieHelper
  ) {}

  ngOnInit(): void {}

  loadHtmlFragment(): Observable<any> {
    let countryCode = this.cookieHelper.getCountryCode();
    if (
      countryCode === undefined ||
      countryCode === null ||
      countryCode === ''
    ) {
      countryCode = this.config.get('APP_DEFAULT_COUNTRY');
    }
    let home_content_url = this.config.get('APP_HOME_CONTENT_URL');
    if (home_content_url.search('{param1}') > 0) {
      home_content_url = home_content_url.replace(
        '{param1}',
        this.urlUtil.getCountryCodeForUrl(countryCode)
      );
      // home_content_url = home_content_url.replace('{param1}', 'us');
    }
    return this._http
      .get(`${home_content_url}`, {
        responseType: 'text'
      })
      .pipe(share());
  }

  loadPEDataWithHtmlRes(peRequest: PERequest) {
    const body = JSON.stringify(peRequest);
    const customheaders = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    });
    customheaders.append('Accept', 'application/json');
    // let body = {"userdata": { "origin": "JUH","destination":"JFK"}, "requestparam": { "campaignId": "shopping-lite:dynamic-banner","format":"html"} };
    return this._http.post(`${this.config.get('APP_PE_CLOUD_URL')}`, body, {
      headers: customheaders,
      responseType: 'text'
    });
  }
}
